import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  type: "",
  search: "",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    typeSelected: (state, action) => {
      state.type = action.payload;
    },
    searchText: (state, action) => {
      state.search = action.payload;
    },
    clearFilter: (state) => {
      state.search = "";
      state.type = "";
    },
  },
});
export const { typeSelected, searchText, clearFilter } = filterSlice.actions;
export default filterSlice.reducer;
